import Axios, { InternalAxiosRequestConfig } from "axios";
import { API_URL } from "@/config";
import { useNotificationStore } from "@/stores/notifications";
import storage from "@/utils/storage";
function getToken(): string | null {
  return storage.getToken();
}

async function authRequestInterceptor(config: InternalAxiosRequestConfig) {
  const token = getToken();
  if (token) {
    config.headers["auth_token"] = `Bearer ${token}`;
  }
  config.headers.Accept = "application/json";
  return config;
}

export const axios = Axios.create({
  baseURL: API_URL,
});
axios.interceptors.request.use(authRequestInterceptor);
axios.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const message = error.response?.data?.message || error.message;
    useNotificationStore.getState().addNotification({
      type: "error",
      title: "Error",
      message,
    });
    return Promise.reject(error);
  }
);
